import type { VistaCard } from "../contratos";

import estilos from "./card.module.css";
import { Bloco, Externo, Frases, Grafico } from "./util";

function SemConclusao({ vista }: { vista: VistaCard }) {
  const { dado } = vista;
  return (
    <>
      <p className={estilos.destaque}>
        <strong>Esta análise mostra o dado oficial e a fonte, sem conclusão.</strong>
        {vista.motivo && ` ${vista.motivo}`}
      </p>
      {vista.tipo && <p>{vista.tipo}</p>}
      {dado ? (
        <p>
          O que o dado oficial mostra: <strong>{dado.valor}</strong> ({dado.nome}, {dado.orgao},{" "}
          {dado.periodo}). Este dado permite saber o valor do indicador nesse período e compará-lo
          com os períodos anteriores, na tabela de “Como ler estes números”.
        </p>
      ) : (
        <p>Não há dado oficial desta versão do Prisma para mostrar sobre esta afirmação.</p>
      )}
    </>
  );
}

function ComConclusao({ vista }: { vista: VistaCard }) {
  const { dado } = vista;
  return (
    <>
      <p className={estilos.destaque}>
        <strong>{vista.guia}</strong> {vista.peso}
      </p>
      {dado && (
        <p>
          Dado oficial exato: <strong>{dado.valor}</strong> ({dado.nome}, {dado.orgao},{" "}
          {dado.periodo}).
          {vista.valor_oficial_exato &&
            vista.valor_oficial_exato !== dado.valor &&
            ` Valor usado na comparação: ${vista.valor_oficial_exato}.`}
        </p>
      )}
      {vista.graficos.peso && (
        <figure className={estilos.figura}>
          <Grafico svg={vista.graficos.peso} />
          <table>
            <caption>Número citado e dado oficial</caption>
            <tbody>
              <tr>
                <th scope="row">Número citado</th>
                <td>{vista.valor_citado}</td>
              </tr>
              <tr>
                <th scope="row">Dado oficial</th>
                <td>{vista.valor_oficial_exato}</td>
              </tr>
            </tbody>
          </table>
        </figure>
      )}
    </>
  );
}

export function Dados({ vista }: { vista: VistaCard }) {
  const { dado } = vista;
  return (
    <Bloco numero={2} titulo="O que os dados mostram">
      {vista.sem_conclusao ? <SemConclusao vista={vista} /> : <ComConclusao vista={vista} />}
      <Frases frases={vista.frases_dados} />
      {dado && (
        <p className={estilos.fonte}>
          Série: <Externo href={dado.pagina}>{`${dado.nome} (${dado.orgao})`}</Externo>. Consulta
          usada: <Externo href={dado.consulta}>dados brutos</Externo>, em {dado.consultado_em}.
        </p>
      )}
      {vista.avisos.length > 0 && (
        <div role="note">
          <p>
            <strong>Avisos</strong>
          </p>
          <ul>
            {vista.avisos.map((a) => (
              <li key={a}>{a}</li>
            ))}
          </ul>
        </div>
      )}
    </Bloco>
  );
}
